import React from "react";
import ChatbotCF from "../../Components/ChatbotCF";

function ChatbotPage(props) {
  return (
    <div className="container-fluid px-3 py-3">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="mb-1">Assistente Codice Fiscale</h2>
          <p className="text-muted mb-0">
            Inserisci un codice fiscale per ottenere un riepilogo completo: dati
            anagrafici decodificati e informazioni presenti nel sistema.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ChatbotCF />
        </div>
      </div>
    </div>
  );
}

export default ChatbotPage;
